var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"White","d":"M42.013,20H20.957a.957.957,0,0,0-.957.957V42.013a.957.957,0,0,0,.957.957H32.2V34.356H29.331V30.767H32.2V27.9c0-2.967,1.878-4.427,4.525-4.427a24.719,24.719,0,0,1,2.675.136v3.1H37.567c-1.439,0-1.775.684-1.775,1.688v2.372h3.589l-.718,3.589H35.792l.057,8.614h6.164a.957.957,0,0,0,.957-.957V20.957A.957.957,0,0,0,42.013,20Z","transform":"translate(-20 -20)","fill":"#fff"}));
}

FacebookInline.defaultProps = {"width":"22.97","height":"22.97","viewBox":"0 0 22.97 22.97"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
